import { Injectable } from '@angular/core';
import { Route, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Utils } from '../../../_helpers/utilities';
import { Router } from '@angular/router';
import { PARTNER_BUILD } from '../../../_helpers/configuration';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard  {

    constructor(private _router: Router) { }

    private getConsentIdFromUrl(url: string): string | null {
        try {
            const queryString = url.split('?')[1];
            if (!queryString) return null;
            const params = new URLSearchParams(queryString);
            return params.get('consent_id');
        } catch (e) {
            return null;
        }
    }

    checkAccess(route: Route, consentId?: string | null): Observable<boolean> | Promise<boolean> | boolean {
        // Check if it's a partner build and consent_id is missing
        if (PARTNER_BUILD && !consentId) {
            this._router.navigate(['/404']);
            return false;
        }

        const loggedIn = Utils.isAuthenticated();
        //RT-11755 If Route is reset_password redirecting to respective route and returning,instead of checking other conditions.
        const isResetPassLink = route.path === 'reset_password';
        if (isResetPassLink) {
            return true;
        }
        if (!loggedIn) {
            return true;
        }
        this._router.navigate(['dashboard']);
        return false;
    }

    canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
        // For canLoad, parse query params from window.location since Route doesn't have query params
        const consentId = this.getConsentIdFromUrl(window.location.href);
        return this.checkAccess(route, consentId);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // For canActivate, get query params from state.url (most reliable) or route.queryParams
        const consentId = this.getConsentIdFromUrl(state.url) || route.queryParams?.consent_id;
        return this.checkAccess(route.routeConfig || {} as Route, consentId);
    }
}
